export const AccountNameCache: { [key: string]: string } = {};
export const AccountSourceCache: { [key: string]: string } = { manual: 'Manual', csv: 'CSV', grouped: 'Grouped' };
export const AccountCountCache: { [key: string]: number } = {};
